import { grey300, grey500, pacific } from './colors';

export default {
    blockquote: `5px solid ${pacific}`,
    abbr: `1px dotted ${grey500}`,
    content: `1px solid ${grey300}`,

    borderRadiuses: {
        base: 3,
        small: 3,
        medium: 5,
        large: 8,
    },
};
